import { useQuery, UseQueryResult } from 'react-query';
import { fetchArticles, fetchArticle } from 'data/queries';
import type { StrapiArticlesResponse, StrapiSingleArticleResponse } from './types';

export const useFetchArticles = (
  page: number = 1,
  pageSize: number = 25
): UseQueryResult<StrapiArticlesResponse> => {
  return useQuery(['articles', page, pageSize], () => fetchArticles(page, pageSize), {
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useFetchArticle = (
  identifier: string
): UseQueryResult<StrapiSingleArticleResponse> => {
  return useQuery(['article', identifier], () => fetchArticle(identifier), {
    enabled: !!identifier,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
